export default __webpack_public_path__ + "static/media/draw-collection.1654d53e.png";